import React from 'react';
import { Sparkles } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';
import { MeshGradient } from '../types/gradients';
import { GradientPreview } from './GradientPreview';
import { ColorPalette } from './ColorPalette';
import { CSSCode } from './CSSCode';

interface GradientDisplayProps {
  gradient: MeshGradient;
}

export function GradientDisplay({ gradient }: GradientDisplayProps) {
  const { isDarkMode } = useTheme();
  const cssCode = `background: linear-gradient(${gradient.angle}deg, ${gradient.colors.join(', ')});`;

  return (
    <div className="w-full max-w-6xl mx-auto">
      <div className="grid grid-cols-1 lg:grid-cols-[1fr,1.5fr] gap-8 p-4 md:p-6">
        <div className="lg:sticky lg:top-24 h-fit">
          <GradientPreview gradient={gradient} />
        </div>

        <div className="flex flex-col gap-8">
          <div className="space-y-4">
            <div className="flex items-center space-x-2">
              <Sparkles className={isDarkMode ? 'text-yellow-400' : 'text-yellow-500'} size={24} />
              <h2 className={`text-2xl md:text-3xl font-serif tracking-[-0.4px] ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                {gradient.name}
              </h2>
            </div>
            <p className={`text-lg leading-relaxed tracking-[-0.4px] ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>
              {gradient.description}
            </p>
          </div>

          <ColorPalette colors={gradient.colors} />
        </div>
      </div>
      <div className="px-4 md:px-6 pb-6">
        <CSSCode cssCode={cssCode} />
      </div>
    </div>
  );
}